import JobseekerRoutes from 'src/route/JobseekerRoutes';
import { useUserContext } from 'src/context/UserProvider';
import MentorRoutes from './MentorRoutes';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import SignIn from 'src/pages/Auth/SignIn';
import SignUp from 'src/pages/Auth/Signup';
import Profile from 'src/pages/profile/Profile';
import RecruiterRoutes from './RecruiterRoutes';
import Job from 'src/pages/Job';
import LinkedInEmptyPage from 'src/pages/LinkedInEmptyPage';
import LinkedinOpenAuth from 'src/pages/LinkedinOpenAuth';
import AccountManagerRoutes from './AccountManagerRoutes';
import AlumniConnectRoutes from './AlumniConnectRoutes';
import LiveSession from 'src/pages/LiveSession';
import UniversityRoutes from './UniversityRoutes';
import GuestUserAssessmentPage from 'src/pages/GuestUserAssessmentPage';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import { OfflineDriveAttendancePage } from 'src/pages/OfflineDriveAttendancePage';
import DriveAdminRoutes from './DriveAdminRoutes';
import OfflineDriveDayOpportunitiesPage from 'src/pages/OfflineDriveDayOpportunitiesPage';
import GuestUserAssessmentDashboard from 'src/components/GuestUserAssessment/GuestUserAssessmentDashboard';
import ScorecardPage from 'src/pages/ScorecardPage';
import { useState, useEffect } from 'react';
import LeadGenRoutes from './LeadGenRoutes';
import { useSearchParams } from 'react-router-dom';
import PlacementDrivesListPage from 'src/pages/placementDrives/PlacementDrivesListPage';
import PlacementDriveDetailPage from 'src/pages/placementDrives/PlacementDriveDetailPage';
import PlacementDriveSignInPage from 'src/pages/placementDrives/PlacementDriveSignInPage';

const PlacementDriveRedirect = () => {
	const { driveId } = useParams();
	return <Navigate to={`/placement-drives/${driveId}/signin`} replace />;
};

const RoutesWrapper = () => {
	const [searchParams] = useSearchParams();
	const hasTokenInUrl = !!searchParams.get('token');
	const {
		isMentorLoggedIn,
		isUserDataLoading,
		isLeadGenLoggedIn,
		isJobseekerLoggedIn,
		isRecruiterLoggedIn,
		isDriveAdminLoggedIn,
		isAlumniConnectLoggedIn,
		isAccountManagerLoggedIn,
		isUserUniversityManagerLoggedIn,
	} = useUserContext();
	const [redirectUrl, setRedirectUrl] = useState('/auth/signin');

	useEffect(() => {
		console.log('window.location.href:', window.location.href);
		const pathname = window.location.pathname
			.replace('/jobseeker', '')
			.replace('/recruiter', '')
			.replace('/university', '')
			.replace('/admin', '');
		if (
			!pathname.includes('/profile') &&
			!pathname.includes('/job') &&
			!pathname.includes('/auth') &&
			!pathname.includes('/linkedin') &&
			!pathname.includes('/hosts') &&
			!pathname.includes('/placed-hiring-assessment') &&
			!pathname.includes('/offline-drive-attendance') &&
			!pathname.includes('/auth') &&
			!pathname.includes('/offline-drive-attendance') &&
			!pathname.includes('/linkedin-auth') &&
			!pathname.includes('/hosts/sessions/live') &&
			!pathname.includes('/scorecard/') &&
			!pathname.includes('/offline-drive-day-opportunities')
		) {
			console.log('window.location.href:', window.location.href);
			setRedirectUrl(`/auth/signin?redirect_url=${window.location.href}`);
		}
	}, []);

	console.log('redirectUrl:', redirectUrl);

	if (isMentorLoggedIn) return <MentorRoutes />;
	if (isLeadGenLoggedIn) return <LeadGenRoutes />;
	if (isJobseekerLoggedIn) return <JobseekerRoutes />;
	if (isRecruiterLoggedIn) return <RecruiterRoutes />;
	if (isDriveAdminLoggedIn) return <DriveAdminRoutes />;
	if (isAccountManagerLoggedIn) return <AccountManagerRoutes />;
	if (isAlumniConnectLoggedIn) return <AlumniConnectRoutes />;
	if (isUserUniversityManagerLoggedIn) return <UniversityRoutes />;

	if (isUserDataLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<NewCreatingPositionLoader
					showAnimation={true}
					progressBar={false}
					customClassCss="!w-[20%] mx-auto"
					startingCustomText={hasTokenInUrl ? 'Signing you in...' : undefined}
				/>
			</div>
		);
	}

	return (
		<Routes>
			<Route path="/linkedin-auth" element={<LinkedinOpenAuth />} />
			<Route path="/linkedin" element={<LinkedInEmptyPage />} />
			<Route path="/auth/register" element={<SignUp />} />
			<Route path="/profile/:userHandler" element={<Profile />} />
			<Route path="/auth/bookADemo" element={<SignIn bookADemo />} />
			<Route path="/auth/signin" element={<SignIn />} />
			<Route path="/job/:jobId" element={<Job />} />
			<Route path="/hosts/sessions/live/:sessionId" element={<LiveSession />} />
			<Route path="/placed-hiring-assessment/:hiringAssessmentId" element={<GuestUserAssessmentPage />} />
			<Route path="/placed-hiring-assessment/all-assessments" element={<GuestUserAssessmentDashboard />} />
			<Route path="/scorecard/:id" element={<ScorecardPage />} />
			<Route path="/placement-drives" element={<PlacementDrivesListPage />} />
			<Route path="/placement-drives/:driveId" element={<PlacementDriveDetailPage />} />
			<Route path="/placement-drives/:driveId/signin" element={<PlacementDriveSignInPage />} />
			<Route path="/placement-drives/:driveId/guest" element={<PlacementDriveSignInPage />} />
			<Route path="/placement-drives/:driveId/apply" element={<PlacementDriveRedirect />} />
			<Route path="/placement-drives/:driveId/resume" element={<PlacementDriveRedirect />} />
			<Route path="/offline-drive-attendance" element={<OfflineDriveAttendancePage />} />
			<Route path="/offline-drive-day-opportunities" element={<OfflineDriveDayOpportunitiesPage />} />
			{!isUserDataLoading ? <Route path="*" element={<Navigate to={redirectUrl} />} /> : null}
		</Routes>
	);
};

export default RoutesWrapper;
